var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h2',[_vm._v("Sign In with")]),_c('button',{on:{"click":_vm.loginGoogle}},[_c('img',{attrs:{"src":require("../assets/icons/btn_google_dark_normal_ios.svg?external"),"alt":"Sign in with Google"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }